<ng-container>
    <app-route-page>
        <div class="d-flex mt-md-5 align-items-center flex-md-row flex-column">
            <img class="col-md-6 col-12" [src]="'../../../../assets/images/login-woman.svg'" [alt]="'login-image'" />
            <div class="d-flex col-md-6 col-12 align-items-center justify-content-center flex-column">
                <app-okta-widget></app-okta-widget>
            </div>
        </div>
    </app-route-page>
</ng-container>
